import { Component, OnDestroy, OnInit } from '@angular/core';
import { SummaryModel } from '@modules/models/summary.model';
import { TransactionService } from '@shared/services/transaction.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-summary-page',
    templateUrl: './summary-page.component.html',
    styleUrls: ['./summary-page.component.css'],
    standalone: false
})
export class SummaryPageComponent implements OnInit, OnDestroy {
  public summaryData!: SummaryModel;
  public listObservers$: Array<Subscription> = [];

  constructor(private _transactionService: TransactionService) {}

  ngOnInit(): void {
    this.summaryData = this._transactionService.getTransactionSummary();
    window.location.href = this.summaryData.result.entityUrl;

    //this.listObservers$ = [observer$];
  }

  ngOnDestroy(): void {
    //this.listObservers$.forEach((o) => o.unsubscribe());
  }
}
